import { COLORS, TEXT_STYLES } from '../../constants/styles';

/**
 * Reusable bullet list component
 */
function BulletList({ items = [], className = '' }) {
  if (!items || items.length === 0) return null;

  return (
    <ul className={`list-none space-y-2 pl-0 ${className}`}>
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-2">
          <span 
            className="flex-shrink-0 w-1.5 h-1.5 rounded-full mt-[0.625rem]" 
            style={{ backgroundColor: COLORS.secondary }}
          />
          <span className={TEXT_STYLES.body}>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export default BulletList;
